// extracted by mini-css-extract-plugin
module.exports = {"main_container":"Main_main_container__1oqRY","main_app_container":"Main_main_app_container__3eX1j"};